<template>
    <div class="">
        <div v-if="vouchers" data-testid="visit-voucher-list">
            <table class="table">
                <thead>
                <tr class="row m-0">
                    <th class="col-md-1"></th>
                    <th class="col-md-5">Lék</th>
                    <th class="col-md-1">Diag.</th>
                    <th class="col-md-1">úhrada</th>
                    <th class="col-md-1">Počet bal.</th>
                    <th class="col-md-1"></th>
                    <th class="col-md-1">Notifikace</th>
                    <th class="col-md-1"></th>
                </tr>
                </thead>
                <tbody>
                    <template v-for="p in vouchers">
                      <tr class="row m-0" :class="(p.status === 'ERROR' ? 'bg-danger-light' : '' )" :data-testid="'visit-voucher-row-' + p.id">
                        <td class="text-left col-md-1">
                          <span class="font-weight-bold">
                                     <i v-if="p.status === 'UNPREPARED'" class="fa fa-minus-circle text-warning" aria-hidden="true" :data-testid="'visit-voucher-status-' + p.id"></i>
                                     <i v-if="p.status === 'ERROR'" class="fa fa-exclamation-circle text-danger" aria-hidden="true" :data-testid="'visit-voucher-status-' + p.id" v-tooltip="{
                                              content: p.last_evoucher_message,
                                              classes: ['danger', 'half']}"></i>
                                     <i v-if="p.status === 'PREPARED'" class="fa fa-check-circle text-success" aria-hidden="true" :data-testid="'visit-voucher-status-' + p.id"></i>
                                     <span class="green">E</span>Poukaz
                                   </span>
                        </td>
                        <td class="align-middle col-md-5">
                                    {{ p.medical_device ? p.medical_device.label : '' }}<br>
                                    {{ p.medical_device ? p.medical_device.description : '' }}
                                </td>
                                <td class="align-middle col-md-1">
                                    {{ p.disease !== null ? p.disease.code : ''}}
                                </td>
                                <td class="align-middle col-md-1">
                                    {{ p.payment ? 'UHR' + p.payment : 'pacient' }}
                                </td>
                                <td class="align-middle col-md-1">
                                    {{ p.quantity }} {{ p.temporary_duration_months ? '(na ' + p.temporary_duration_months + ' měs.)' : '' }}
                                </td>
                                <td class="align-middle col-md-1">
<!--                                    {{ m.dosage }}-->
                                </td>
                                <td class="align-middle col-md-1">
                                    <span v-if="p.patient_notification_type === 'SMS'">SMS</span>
                                    <span v-else-if="p.patient_notification_type === 'EMAIL'">e-mail</span>
                                    <span v-else="" class="fa fa-minus" aria-hidden="true"></span>
                                </td>
                                <td class="text-left col-md-1">
                                    <template v-if="p.status !== 'DELETED'">
                                        <template v-if="p.type === 'printed' || p.status === 'UNPREPARED'">
                                            <button class="btn btn-sm btn-danger btn_line-heigh-1" @click="removeVoucher(p)" :data-testid="'visit-voucher-delete-' + p.id"><i class="fa fa-trash" aria-hidden="true"></i></button>
                                        </template>
                                        <template v-if="toDeleteElectronicPrescriptionId === p.id">
                                            <input v-model="toDeleteElectronicPrescriptionReason" type="text" class="form-control form-control-sm" aria-describedby="reason" id="reason" placeholder="důvod zrušení eR." :data-testid="'visit-voucher-cancel-reason-' + p.id">
                                            <button class="btn btn-sm btn-danger btn_line-heigh-1" @click="removeVoucher(p)" :data-testid="'visit-voucher-delete-' + p.id"><i class="fa fa-trash" aria-hidden="true"></i></button>
                                        </template>
                                        <template v-else="">
                                            <template v-if="p.status === 'PREPARED'">
                                                <button class="btn btn-sm btn-danger btn_line-heigh-1" @click="setElectronicOPrescriptionToDelete(p.id)" :data-testid="'visit-voucher-delete-' + p.id"><i class="fa fa-times" aria-hidden="true"></i></button>
                                            </template>

<!--                                            <template v-if="p.type === 'printed' || p.status === 'PREPARED'">-->
<!--                                                <a target="_blank" :href="hostname.hostname + 'prescription/printed/pdf?id=' + p.id" class="btn btn-sm btn-success btn_line-heigh-1"><i class="fa fa-print" aria-hidden="true"></i></a>-->
<!--                                            </template>-->

                                        </template>
                                        <template v-if="p.status === 'ERROR'">
                                            <button class="btn btn-sm btn-primary btn_line-heigh-1" @click="sendToSuklElectronicVoucher(p.id)" :data-testid="'visit-voucher-retry-' + p.id"><i class="fa fa-repeat" aria-hidden="true"></i></button>
                                        </template>
                                    </template>
                                    <template v-else="">
                                        <span class="text-danger font-weight-bold">SMAZÁNO</span>
                                    </template>
                                </td>
                            </tr>
                        </template>
                    <template v-if="vouchers.length > 0">
                        <tr class="row m-0">
                            <td class="col-md-5"></td>
                            <td class="text-left col-md-4 pt-2">
                                <button class="btn btn-sm btn-secondary" @click="updateVouchers()" data-testid="visit-voucher-refresh">aktualizuj seznam</button>
<!--                                <template v-if="vouchersPrintedCount > 0">-->
<!--                                  <a target="_blank" :href="hostname.hostname + 'prescription/printed/pdf?visit_id=' + visitId" class="btn btn-sm btn-success" v-if="visitId"><i class="fa fa-print" aria-hidden="true"></i> poukazy ({{ vouchersPrintedCount }})</a>-->
<!--                                  <a target="_blank" :href="hostname.hostname + 'prescription/printed/pdf?client_id=' + clientId + '&date=' + $moment().format('DD.MM.YYYY')" class="btn btn-sm btn-success" v-else><i class="fa fa-print" aria-hidden="true"></i> poukazy ({{ vouchersPrintedCount }})</a>-->
<!--                                </template>-->
<!--                                <a target="_blank" class="btn btn-sm btn-success disabled" v-else=""><i class="fa fa-print" aria-hidden="true"></i> poukazy (0)</a>-->

<!--                                <button class="btn btn-sm btn-secondary disabled btn_line-heigh-1" v-if="hasUnpreparedElectronicPrescription" @click="showEPrescriptionModal">Doplnit eRecepty</button>-->
                            </td>
                        </tr>
                    </template>
                </tbody>
            </table>
        </div>
        <div class="text-center" v-else-if="vouchersPending">
            <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i><br/>
            (načítám)
        </div>
        <div class="text-center" v-else="" data-testid="visit-voucher-empty">
            (žádný poukaz nebyl vypsán)
        </div>
    </div>
</template>

<script>
  import apiMixin from '@/mixins'
  // import ElectronicPrescription from '@/views/Client/modals/ElectronicPrescription.vue'

  export default {
    data () {
      return {
        hostname: require('@/variables.js'),
        // Vouchers
        vouchers: false,
        vouchersPending: false,
        vouchersError: false,
        // single medicalDevices,
        selectedSeparatedIds: [],
        selectedEPrescriptionIds: [],
        allMedicamentIds: [],
        // post vouchers
        hasUnpreparedElectronicPrescription: false,

        toDeleteElectronicPrescriptionReason: '',
        toDeleteElectronicPrescriptionId: null,
        // resend electronic voucher
        sendToSuklElectronicVoucherDone: false,
        // delete electronic voucher
        deleteElectronicVoucherPending: false,
        deleteElectronicVoucherError: false,
        deleteElectronicVoucherDone: false
      }
    },
    props: ['doUpdate', 'clientId', 'visitId'],
    mixins: [apiMixin],
    computed: {
      vouchersPrintedCount () {
        let count = 0
        for (let index = 0; index < this.vouchers.length; index++) {
          if (this.vouchers[index].type === 'printed' || (this.vouchers[index].type === 'electronic' && this.vouchers[index].status === 'PREPARED')) {
            count++
          }
        }

        return count
      },
      vouchersElectronicCount () {
        this.hasUnpreparedElectronicPrescription = false
        let count = 0
        for (let index = 0; index < this.vouchers.length; index++) {
          if (this.vouchers[index].type === 'electronic') {
            if (this.vouchers[index].status === 'PREPARED') {
              count++
            }
            if (this.vouchers[index].status === 'UNPREPARED') {
              this.hasUnpreparedElectronicPrescription = true
            }
          }
        }

        return count
      }
    },
    methods: {
      // showModal (name) {
      //   this.$modal.show(name)
      // },
      // showEPrescriptionModal () {
      //   this.modalEPrescriptionOpened = true
      //   this.showModal('electronic-prescription')
      // },
      removeVoucher (ep) {
        if (ep.type === 'printed') {
          //
        } else {
          ep.reason = this.toDeleteElectronicPrescriptionReason
          this.deleteElectronicVoucher(ep)
        }
      },
      setElectronicOPrescriptionToDelete (id) {
        this.toDeleteElectronicPrescriptionId = id
      },
      updateVouchers () {
        if (this.visitId) {
          this.getVouchers(this.visitId)
        } else {
          this.getClientVouchers(this.clientId, this.$moment().format('DD.MM.YYYY'))
        }
        this.$emit('updated')
      }
    },
    watch: {
      doUpdate (val) {
        if (val === true) {
          this.updateVouchers()
        }
      },
      visitId () {
        this.updateVouchers()
      },
      clientId () {
        this.updateVouchers()
      },
      deleteElectronicPrescriptionDone (val) {
        if (val === true) {
          this.updateVouchers()
          this.deleteElectronicPrescriptionDone = false
        }
      },
      sendToSuklElectronicVoucherDone (val) {
        if (val === true) {
          this.updateVouchers()
          this.sendToSuklElectronicVoucherDone = false
        }
      }
    },
    beforeMount () {
      this.updateVouchers()
    }
    // components: {
    //   ElectronicPrescription
    // }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .table th, .table td {
        padding: 1px;
    }

    .no-top-border {
        border-top: none;
    }

    .btn_line-heigh-1 {
        line-height: 1;
    }

    td.empty_cell {
        border-top: none !important;
    }

    span.green {
        color: green;
    }

</style>



// WEBPACK FOOTER //
// src/views/Voucher/ListVoucher.vue?44cb0680